import ResetPasswordForm from "@/components/Auth/ResetPasswordForm";
import ContentWrapper from "@/components/Common/Containers/ContentContainer";
import React from "react";
import { useTranslation } from "react-i18next";

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <div className="flex-grow flex items-center justify-center px-4 md:bg-gradient-to-b from-custom-blue to-custom-purple min-h-screen">
        <div className="w-full max-w-4xl flex flex-col md:flex-row">
          <div className="hidden order-last md:order-first w-full md:w-1/2 pr-8 md:flex flex-col justify-center">
            <h2 className="text-xl md:text-2xl mb-4">
              {t("auth.sootchy_program.title", {
                partnerName: window?.partner?.title ?? "Sootchy",
              })}
            </h2>
            <ul className="space-y-2">
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.auto_setup")}
              </li>
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.employer_match")}
              </li>
              <li className="flex items-center py-2">
                <svg
                  className="w-5 h-5 text-green-500 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t("auth.sootchy_program.benefits.tax_free_growth")}
              </li>
            </ul>
          </div>

          <ResetPasswordForm />
        </div>
      </div>
    </ContentWrapper>
  );
};

export default ResetPassword;
